<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="toc"><span class="epub-bi">Contents</span></p>
<p class="toc"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="toc"><span href="#/xhtml/copyrightnotice#notice" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="toc-bot"><a href="#/xhtml/ack#ack">Acknowledgments</a></p>
<p class="toc"><a href="#/xhtml/chapter1#ch1">Cannibal Kings</a></p>
<p class="toc"><a href="#/xhtml/chapter2#ch2">How It Was for Me</a></p>
<p class="toc"><span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample">Lost Causes</span></p>
<p class="toc"><span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">Life Is Over There</span></p>
<p class="toc"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">Blame It on My Youth</span></p>
<p class="toc"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">Titipu</span></p>
<p class="toc"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">The Art of Eating</span></p>
<p class="toc"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">The Walker</span></p>
<p class="toc"><span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">Four Bites</span></p>
<p class="toc"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">The Future of the Flynns</span></p>
<p class="toc-bot"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">Come Live with Me and Be My Love</span></p>
<p class="toc"><span href="#/xhtml/adcard#ad" title="Link target outside of Sample">Also By Andrew Sean Greer</span></p>
<p class="toc"><span href="#/xhtml/praise#praise" title="Link target outside of Sample">Additional Acclaim for <span class="epub-i">How It Was for Me</span></span></p>
<p class="toc"><span href="#/xhtml/copyright#crt" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?4674a4ee